import { render, staticRenderFns } from "./Gaming.vue?vue&type=template&id=74f06be5&scoped=true&"
import script from "./Gaming.vue?vue&type=script&lang=js&"
export * from "./Gaming.vue?vue&type=script&lang=js&"
import style0 from "./Gaming.vue?vue&type=style&index=0&id=74f06be5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f06be5",
  null
  
)

export default component.exports